import FiltersComponent from 'component/filters/Filter';
import ShowMoreFilterComponent from 'component/filters/ShowMoreFilter';
import CategoryFiltersComponent from 'component/filters/CategoryFilters';
import CategoryGameTypeFilterComponent from 'component/filters/CategoryGameTypeFilter';

export { FiltersComponent }
export { ShowMoreFilterComponent }
export { CategoryFiltersComponent }
export { CategoryGameTypeFilterComponent }

export default Object.assign({
	FiltersComponent,
	ShowMoreFilterComponent,
	CategoryFiltersComponent,
	CategoryGameTypeFilterComponent
})